import { RemoteGetPerformanceReportForProfessionalsRanking } from 'data/usecases';
import { GetPerformanceReportForProfessionalsRankingUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPerformanceReportForProfessionalsRanking } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetPerformanceReportForProfessionalsRanking =
  (): GetPerformanceReportForProfessionalsRankingUseCaseInterface =>
    new RemoteGetPerformanceReportForProfessionalsRanking(
      makeApiUrlPerformanceReportForProfessionalsRanking(),
      makeAxiosHttpClient(),
    );
